import { prepareInvitationCommon, } from './prepare-invitation-common';
export const prepareOrganizationInvitation = async ({ adminCrypto, workspaceId, }) => {
    const adminKeys = await adminCrypto.verifyAndGetAdminKeys();
    const [workspaceCommonKey, everyoneKeys, workspaceSecretKey] = await Promise.all([
        adminCrypto.getWorkspaceCommonKey(),
        adminCrypto.verifyAndGetEveryoneKeys(),
        adminCrypto
            .getSsoCrypto()
            .then((ssoCrypto) => ssoCrypto.verifyAndGetSsoSecretKey()),
    ]);
    return prepareInvitationCommon({
        workspaceId: workspaceId,
        adminKeys,
        workspaceCommonKey,
        everyonePrivateKey: everyoneKeys.privateKey,
        workspaceSecretKey,
    });
};
